import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/contexts/AuthContext'
import { DashboardView } from '@/components/dashboard/DashboardView'

export const Route = createFileRoute('/admin/dashboard')({
  component: DashboardPage,
})

function DashboardPage() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" />
  return <DashboardView />
}